import { db } from '@/globals'

// initial state
const state = () => ({
  productAvailable: {},
})

// getters
const getters = {
  isAvailable: (state) => (productId) => {
    if (state.productAvailable[productId] != undefined) {
      return state.productAvailable[productId]
    } else {
      return true
    }
  }
}

// actions
const actions = {}

// mutations
const mutations = {
  setAvailable(state, payload) {
    state.productAvailable[payload.product] = payload.available
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
